import api from './api';

const d = (r) => r.data;
const N = '/api/ato-nominations';
const mp = (body) => ({ headers: { 'Content-Type': 'multipart/form-data' } });

export const STATUS_TONE = {
  nomination_requested: 'bg-amber-100 text-amber-800', help_requested: 'bg-orange-100 text-orange-800', client_confirmed: 'bg-sky-100 text-sky-800',
  verification_pending: 'bg-sky-100 text-sky-800', nomination_verified: 'bg-indigo-100 text-indigo-800', agent_linking_pending: 'bg-indigo-100 text-indigo-800',
  linked: 'bg-emerald-100 text-emerald-800', completed: 'bg-emerald-100 text-emerald-800', not_found: 'bg-red-100 text-red-800',
  nomination_expired: 'bg-red-100 text-red-800', re_nomination_required: 'bg-red-100 text-red-800', linking_failed: 'bg-red-100 text-red-800', not_required: 'bg-slate-100 text-slate-700',
};

export const nominationAPI = {
  settings: () => api.get(`${N}/settings`).then(d),
  saveSettings: (body) => api.put(`${N}/settings`, body).then(d),
  list: (params) => api.get(N, { params }).then(d),
  exportCsv: (params) => api.get(`${N}/export`, { params, responseType: 'blob' }).then(d),
  bulkAssign: (ids, assigneeId) => api.post(`${N}/bulk-assign`, { ids, assignee_id: assigneeId }).then(d),
  client: (cid) => api.get(`/api/clients/${cid}/ato-nominations`).then(d),
  summary: (cid) => api.get(`/api/clients/${cid}/ato-nomination-summary`).then(d),
  assess: (cid) => api.post(`${N}/assess/${cid}`).then(d),
  act: (id, action, body) => api.post(`${N}/${id}/${action}`, body || {}).then(d),
  users: () => api.get('/api/users').then(d),
  my: () => api.get('/api/my/ato-nominations').then(d),
  myProgress: (id, body) => api.post(`/api/my/ato-nominations/${id}/progress`, body).then(d),
  myConfirm: (id, { nominationDate, reference, file }) => {
    const f = new FormData();
    f.append('nomination_date', nominationDate); f.append('declaration', 'true'); f.append('reference', reference || '');
    if (file) f.append('file', file);
    return api.post(`/api/my/ato-nominations/${id}/confirm`, f, mp()).then(d);
  },
  myHelp: (id, message, topic) => api.post(`/api/my/ato-nominations/${id}/help`, { message, topic }).then(d),
  contacts: (id) => api.get(`${N}/${id}/contacts`).then(d),
  sendAuthorisedPerson: (id, body) => api.post(`${N}/${id}/authorised-person`, body).then(d),
  bulkRemind: (ids) => api.post(`${N}/bulk-remind`, { ids }).then(d),
  reminders: (id) => api.get(`${N}/${id}/reminders`).then(d),
  helpReply: async (r, body) => {
    if (r.help_conversation_id) return api.post(`/api/communications/conversations/${r.help_conversation_id}/messages`, { body }).then(d);
    const c = await api.post('/api/communications/conversations', { client_id: r.help_thread_client_id || r.client_id, subject: `ATO nomination help – ${r.client_name}`, body }).then(d);
    return api.post(`${N}/${r.id}/help-thread`, { conversation_id: c.conversation.id }).then(d);
  },
  register: (params) => api.get(`${N}/register`, { params }).then(d),
  registerExport: (params) => api.get(`${N}/register/export`, { params, responseType: 'blob' }).then(d),
  registerCorrect: (id, body) => api.post(`${N}/register/${id}/correction`, body).then(d),
  complianceSummary: (clientId) => api.get(`${N}/compliance-summary`, { params: clientId ? { client_id: clientId } : {} }).then(d),
  imports: () => api.get(`${N}/report-imports`).then(d),
  importGet: (id) => api.get(`${N}/report-imports/${id}`).then(d),
  importUpload: (file) => { const f = new FormData(); f.append('file', file); return api.post(`${N}/report-imports`, f, mp()).then(d); },
  importMapping: (id, mapping) => api.put(`${N}/report-imports/${id}/mapping`, { mapping }).then(d),
  importApply: (id) => api.post(`${N}/report-imports/${id}/apply`).then(d),
  importMarkVerified: (id, idx) => api.post(`${N}/report-imports/${id}/rows/${idx}/mark-verified`).then(d),
  myRestart: (id) => api.post(`/api/my/ato-nominations/${id}/restart`).then(d),
  myExtension: (id, date) => api.post(`/api/my/ato-nominations/${id}/extension`, { extension_date: date }).then(d),
};
